import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import axios from "axios";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    level: 0,
    isLoggedIn: !!localStorage.getItem("token"),
    userType: localStorage.getItem("userType"),
    // userType: 'Client',
    cartItems: 0,
    wishlistItems: 0,
    userData: {},
    userDetailed: {},
    category: null,
    categoryId: null,
    coupen: {},
    buyNGetMDeal: 0,
    loginAlternate: false,
    fullPath: null,
    categories: [],
    subCategoryList: [],
    stylCategories: [],
    subCategories: [],
    profileStatus: null,
    profileCondition: null,
		searchData: null,
  },
  mutations: {
    loginUser(state, item) {
      state.isLoggedIn = item;
      if (state.userType == "customer") {
        router.push("/Login");
      }
    },

    LOGIN_ALTERNATE(state, item) {
      state.loginAlternate = item;
    },

    lastPage_fullPath(state, item) {
      // console.log(state,item,"fghj")
      state.fullPath = item;
    },

    logoutUser(state) {
      axios({
        method: "post",
        url: "user/logout",
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data) {
          state.userType = "seller";
          state.userData = {};
          state.coupen = {};
          localStorage.setItem("userType", "seller");
          state.isLoggedIn = false;
          state.cartItems = 0;
          state.wishlistItems = 0;
          localStorage.removeItem("token");
          localStorage.removeItem("categoryId");
          localStorage.removeItem("category");
					localStorage.removeItem("profStat");

          router.push("/Login");
        }
      });
    },
    changeCart(state, item) {
      state.cartItems = item;
    },
    changeWishlist(state, item) {
      state.wishlistItems = item;
    },
    userData(state, item) {
      state.userData = item;
    },
    userDetailed(state, item) {
      state.userDetailed = item;
      localStorage.setItem("profStat", item.profileStatus);
    },
    coupen(state, item) {
      state.coupen = item;
    },
    changePicture(state, item) {
      state.userData.image = item;
    },
    changeCoverPicture(state, item) {
      state.userData.seller.coverimage = item;
    },
    userType(state, item) {
      state.userType = item;
      localStorage.setItem("userType", item);
    },
    registrationStage(state, item) {
      state.level = item;
    },
    profilestatus(state, item) {
      state.profileStatus = item;
		},
		
    searchedFor(state, item) {
      state.searchData = item;
    },
    userCategory(state, item) {
      state.category = item.name;
      state.categoryId = item._id;
      localStorage.setItem("category", item.name);
      localStorage.setItem("categoryId", item._id);
    },
    userSubCategory(state, item) {
      state.subCategoryList = item;
    },
    changeBuyNGetMDeal(state, item) {
      state.buyNGetMDeal = item;
    },
    sessionOut(state) {
      localStorage.removeItem("token");
      state.isLoggedIn = false;
      router.push("/Login");
    },
    // SET_CATEGORIES(state, categories) {
    // 	state.categories = categories
    // },
    // SET_STYLCATEGORIES(state, stylCategories) {
    // 	state.stylCategories = stylCategories
    // },
    // SET_SUBCATEGORIES(state, subCategories) {
    // 	state.subCategories = subCategories
    // }
  },
  actions: {
    
  },
});
